<template>
    <div class="card" @click="$router.push(`/inventory/${equipment.id}`)">
        <img class="card-img-top" v-show="image" :src="image" :alt="equipment.title">
        <div class="card-body">
            <h5 class="card-title">{{ equipment.title }}</h5>
            <!-- Tab panes -->
            <div>{{ equipment.content | max }}</div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    props: ['equipment'],
    computed: {
        image() {
            return _.get(this.equipment, 'images.0.url')
        }
    },
    filters: {
        max(text, length = 150, omission = '...') {
            return _.truncate(text, {
                length: length,
                omission: omission
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/InventoryItem.vue